<template>
    <div id="advance-search">
        <div class="row">
            <div class="px-3">
                <a href="#" @click="toggleSearch(), adjustHeight()">
                    <p class="text-primary text-left fs-12">
                        <font-awesome-icon class="mr-3 search-arrow" v-bind:class="{ 'fa-rotate-90': activateSearch }" :icon="['fas', 'chevron-right']" />
                        {{ $t('advance-search') }}
                    </p>
                </a>
            </div>
        </div>
        <div class="container-fluid search-section mb-2" v-bind:class="{ hidden: !activateSearch, searchDate: pickDate}">
            <div class="row">
                <div class="col-sm text-left">
                    <span class="fs-14"><font-awesome-icon class="mr-3 text-primary" :icon="['far', 'calendar-alt']"/>{{ $t('select-date') }} : </span>
                    <date-range-picker
                        class="mb-2"
                        ref="picker"
                        :auto-apply="true"
                        v-on:toggle="overflowCheck()"
                        v-model="dateRange"
                        @update="searchDates()"
                        opens="right"
                        :locale-data="localeData"
                        :ranges="localeData.ranges">
                    </date-range-picker>
                    <small class="text-primary ml-4 erase-date" v-if="dateRange.startDate" @click="clearDates">{{ $t('clear-date') }}</small>
                </div>
            </div>
            <form>
                <div class="form-row">
                    <div id="withTagWrap" class="form-group col-md-12 col-lg-6 text-left mb-0 pb-0">
                        <label class="fs-12 text-dark-brown">{{ $t('with-tag') }}</label>
                        <base-chips-input
                            :value="selectedWithTags"
                            :suggestions="availableTags"
                            :allow-create="false"
                            :placeholder="$t('add-tag')"
                            :label="$t('with-tag')"
                            chip-class="is-with"
                            @input="updateTags('selectedWithTags', 'with-tag-search', $event)"
                        ></base-chips-input>
                    </div>
                    <div id="withoutTagWrap" class="form-group col-md-12 col-lg-6 text-left mb-0 pb-0">
                        <label class="fs-12 text-dark-brown">{{ $t('without-tag') }}</label>
                        <base-chips-input
                            :value="selectedWithoutTags"
                            :suggestions="availableTags"
                            :allow-create="false"
                            :placeholder="$t('add-tag')"
                            :label="$t('without-tag')"
                            chip-class="is-without"
                            @input="updateTags('selectedWithoutTags', 'without-tag-search', $event)"
                        ></base-chips-input>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

// Internal services js
import { EventBus }   from '../../../helpers/EventBus.js';
import BaseChipsInput from '@/core/components/BaseChipsInput.vue';

// External libraries
import DateRangePicker            from 'vue2-daterange-picker';
import { mapGetters, mapActions } from 'vuex';
import moment                     from 'moment';

// You need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
    components: {
        BaseChipsInput,
        DateRangePicker
    },

    created () {
        // Get tge tags
        this.index();

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        yesterday.setHours(0, 0, 0, 0);

        this.localeData.ranges[this.$i18n.t('today')]      = [today, today];
        this.localeData.ranges[this.$i18n.t('yesterday')]  = [yesterday, yesterday];
        this.localeData.ranges[this.$i18n.t('this-year')]  = [
            new Date(moment().clone().startOf('year').format('YYYY-MM-DD hh:mm')),
            new Date(moment().clone().endOf('year').format('YYYY-MM-DD hh:mm'))
        ];
        this.localeData.ranges[this.$i18n.t('last-month')] = [
            new Date(moment().subtract(1,'months').clone().startOf('month').format('YYYY-MM-DD hh:mm')),
            new Date(moment().subtract(1,'months').clone().endOf('month').format('YYYY-MM-DD hh:mm'))
        ];
    },

    data () {
        return {
            selectedWithTags:    [],
            selectedWithoutTags: [],
            pickDate:            false,
            activateSearch:      false,
            dateRange:           {
                startDate: '',
                endDate:   ''
            },
            localeData: {
                applyLabel:  this.$i18n.t('search'),
                cancelLabel: this.$i18n.t('cancel'),
                ranges:      {},
                daysOfWeek:  [this.$i18n.t('su'), this.$i18n.t('mo'), this.$i18n.t('tu'), this.$i18n.t('we'), this.$i18n.t('th'), this.$i18n.t('fr'), this.$i18n.t('sa')],
                monthNames:  [this.$i18n.t('january'), this.$i18n.t('february'), this.$i18n.t('march'), this.$i18n.t('april'), this.$i18n.t('may'), this.$i18n.t('june'), this.$i18n.t('july'), this.$i18n.t('august'), this.$i18n.t('september'), this.$i18n.t('october'), this.$i18n.t('november'), this.$i18n.t('december')]
            }
        };
    },

    computed: {
        ...mapGetters('core/tags', {
            'allTags': 'tags'
        }),

        availableTags () {
            const used = [...this.selectedWithTags, ...this.selectedWithoutTags];

            return Object.values(this.allTags || {})
                .map(tag => tag.attributes.name)
                .filter(name => !used.includes(name));
        }
    },

    methods: {
        ...mapActions('core/tags', [
            'index'
        ]),

        // Send date range to the contact list
        searchDates () {
            EventBus.$emit('startDateSearch', this.dateRange.startDate);
            EventBus.$emit('endDateSearch', this.dateRange.endDate);
        },

        // Clear the date range and the input
        clearDates () {
            this.dateRange.startDate = null;
            this.dateRange.endDate = null;
            EventBus.$emit('startDateSearch', this.dateRange.startDate);
            EventBus.$emit('endDateSearch', this.dateRange.endDate);
        },

        // Close date picker calendar if the advance search box is close
        toggleSearch () {
            this.activateSearch = !this.activateSearch;
            if (this.activateSearch === false && this.pickDate === true) {
                this.pickDate = false;
            }
        },

        /**
         * Update a tag list of the search query and send it to the contact list
         *
         * @param {string}  list   The list to update.
         * @param {string}  event  The event sent to the contact list.
         * @param {array}   tags   The new tags.
         */
        updateTags (list, event, tags) {
            this[list] = tags;
            EventBus.$emit(event, tags);
        },

        // Adjust the contact list height when the advance search is open
        adjustHeight () {
            EventBus.$emit('advance-search');
        },

        // Datepicker modal overflow
        overflowCheck () {
            if (this.$refs['picker'].open === true) {
                this.pickDate = true;
            }
        }
    }
};
</script>
